var _defs, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCircle(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 611.226,
    height: 611.231,
    viewBox: "0 0 611.226 611.231",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "a",
    x1: 0.5,
    x2: 0.5,
    y2: 1,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#02ddb7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#03d077"
  })))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M305.611,611.231a307.877,307.877,0,0,1-61.593-6.209A303.912,303.912,0,0,1,134.74,559.036,306.492,306.492,0,0,1,24.014,424.575,304.013,304.013,0,0,1,6.207,367.209a308.693,308.693,0,0,1,0-123.184A303.948,303.948,0,0,1,52.191,134.744,306.525,306.525,0,0,1,186.652,24.017,304.1,304.1,0,0,1,244.018,6.209,307.685,307.685,0,0,1,403.8,16.12a304.2,304.2,0,0,1,84.953,44.84A307.6,307.6,0,0,1,555.18,129.24a303.824,303.824,0,0,1,56.045,176.378,307.992,307.992,0,0,1-6.211,61.591,303.942,303.942,0,0,1-45.984,109.279A306.532,306.532,0,0,1,424.57,587.214,304.079,304.079,0,0,1,367.2,605.022,307.878,307.878,0,0,1,305.611,611.231ZM305.845,55.3C167.688,55.3,55.293,167.7,55.293,305.851S167.688,556.4,305.845,556.4,556.4,444.007,556.4,305.851,444,55.3,305.845,55.3Z",
    fill: "url(#a)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCircle);
export default __webpack_public_path__ + "static/media/circle.5e7417f786cac77febf906ed3316ce64.svg";
export { ForwardRef as ReactComponent };